/**
 * GRID-OS Digital Friction Check — German string pack
 * ---------------------------------------------------------------------------
 * Display strings only. This file MUST NOT contain scoring, ids, HubSpot
 * property names, answer codes, event names or any other wire value.
 *
 * Everything here is overlaid on the English defaults in
 * grid-os-assessment-config.js at load time. The English values stay
 * reachable as `wire*` fields and are what HubSpot and the result summary
 * receive, so translating this file can never split a CRM report.
 *
 * Load order matters: this file must execute BEFORE the config file.
 *
 * Register: window.GridOsAssessmentStrings.de
 */

window.GridOsAssessmentStrings = window.GridOsAssessmentStrings || {};

window.GridOsAssessmentStrings.de = {
  language: 'de',

  areas: {
    leadership:      { name: 'Digitale Prioritäten & Führung',       shortName: 'Führung' },
    website_ux:      { name: 'Website, UX & Conversion',             shortName: 'Website & UX' },
    discoverability: { name: 'SEO, Content & Auffindbarkeit',        shortName: 'Auffindbarkeit' },
    coordination:    { name: 'Teams, Agenturen & Verantwortung',     shortName: 'Koordination' },
    measurement:     { name: 'Messung & Roadmap',                    shortName: 'Messung & Roadmap' }
  },

  areaBands: {
    critical:   { label: 'Kritische Reibung' },
    fragmented: { label: 'Fragmentiert' },
    developing: { label: 'Im Aufbau' },
    aligned:    { label: 'Ausgerichtet' }
  },

  questions: {
    q01_priority_clarity: {
      text: 'Wie klar sind die digitalen Prioritäten Ihres Unternehmens für die nächsten 90 Tage definiert?',
      answers: {
        A: 'Wir haben keine definierten digitalen Prioritäten.',
        B: 'Einzelne Bereiche haben eigene Prioritäten, ein gemeinsames Bild fehlt.',
        C: 'Es gibt grobe Prioritäten, aber ohne klare Rangfolge und ohne Zeitbezug.',
        D: 'Wir haben abgestimmte 90-Tage-Prioritäten, einzelne Details oder Abhängigkeiten bleiben offen.',
        E: 'Wir haben klar priorisierte und kommunizierte 90-Tage-Prioritäten, die unsere Entscheidungen leiten.'
      }
    },
    q02_senior_ownership: {
      text: 'Gibt es eine eindeutig verantwortliche Führungsperson, die digitale Prioritäten mit der Umsetzung verbindet?',
      answers: {
        A: 'Niemand trägt derzeit die Gesamtverantwortung.',
        B: 'Die Verantwortung ist verteilt und häufig unklar.',
        C: 'Jemand koordiniert informell, hat aber weder klare Befugnis noch ausreichend Kapazität.',
        D: 'Eine verantwortliche Führungsperson ist benannt, einzelne Entscheidungen bleiben jedoch verteilt.',
        E: 'Eine Führungsperson hat klare Verantwortung, Entscheidungsbefugnis und Überblick über Strategie und Umsetzung.'
      }
    },
    q03_website_clarity: {
      text: 'Wie klar vermittelt Ihre Website, was Sie anbieten, für wen es gedacht ist und warum Kunden sich für Sie entscheiden sollten?',
      answers: {
        A: 'Die Website bildet unser Geschäft nicht mehr zutreffend ab.',
        B: 'Besucher erkennen, was wir tun, aber Zielgruppe und Nutzen bleiben unklar.',
        C: 'Das Hauptangebot ist verständlich, die Botschaften sind jedoch uneinheitlich oder zu allgemein.',
        D: 'Angebot, Zielgruppe und Nutzen sind weitgehend klar, einzelne Bereiche brauchen Nacharbeit.',
        E: 'Die Website vermittelt über die gesamte Customer Journey ein klares Angebot, eine klare Zielgruppe und einen differenzierten Nutzen.'
      }
    },
    q04_conversion_visibility: {
      text: 'Wie gut erkennt Ihr Team, an welchen Stellen Website-Besucher zögern, abbrechen oder nicht konvertieren?',
      answers: {
        A: 'Wir messen oder untersuchen das Conversion-Verhalten derzeit nicht.',
        B: 'Wir haben grundlegende Zugriffszahlen, aber kaum Verständnis für das Nutzerverhalten.',
        C: 'Wir erkennen einzelne Problemstellen, die Auswertung ist jedoch unregelmäßig oder lückenhaft.',
        D: 'Wir beobachten die wichtigsten Journeys und erkennen die meisten relevanten Conversion-Probleme.',
        E: 'Wir verbinden Analytics, Nutzerbelege und Tests systematisch, um Conversion-Reibung zu erkennen und zu beheben.'
      }
    },
    q05_commercial_alignment: {
      text: 'Wie eng sind Ihre SEO- und Content-Aktivitäten mit Ihren geschäftlichen Prioritäten verbunden?',
      answers: {
        A: 'Wir haben kaum oder gar kein aktives SEO- und Content-Programm.',
        B: 'Inhalte entstehen gelegentlich, ohne klare geschäftliche Prioritäten.',
        C: 'Einzelne Aktivitäten zahlen auf Geschäftsziele ein, Planung und Messung sind aber uneinheitlich.',
        D: 'Der Großteil der SEO- und Content-Arbeit ist mit definierten Zielgruppen, Angeboten und Ergebnissen verknüpft.',
        E: 'SEO und Content werden systematisch nach geschäftlichen Zielen priorisiert, produziert und gemessen.'
      }
    },
    q06_search_ai_visibility: {
      text: 'Wie klar verstehen Sie, wie potenzielle Kunden Ihr Unternehmen über Suchmaschinen und KI-generierte Antworten finden?',
      answers: {
        A: 'Wir haben keinen Einblick, wie Kunden uns über Suche oder KI finden.',
        B: 'Wir kennen einige wichtige Suchbegriffe, verfolgen die Entwicklung aber nicht konsequent.',
        C: 'Wir beobachten die organische Suche, KI-Sichtbarkeit und weitere Wege bleiben jedoch unklar.',
        D: 'Wir kennen unsere wichtigsten Suchanfragen und haben begonnen, die Sichtbarkeit in KI-Antworten zu bewerten.',
        E: 'Wir beobachten systematisch Suchnachfrage, Rankings, KI-Erwähnungen, Markendarstellung und die daraus entstehenden Conversions.'
      }
    },
    q07_shared_priorities: {
      text: 'Inwieweit arbeiten interne Teams, Agenturen und Dienstleister nach denselben Prioritäten?',
      answers: {
        A: 'Jedes Team und jeder Dienstleister arbeitet für sich.',
        B: 'Prioritäten werden informell kommuniziert und häufig unterschiedlich verstanden.',
        C: 'Einzelne Teams teilen ihre Pläne, die Abstimmung über Arbeitsstränge hinweg ist aber uneinheitlich.',
        D: 'Die meisten Beteiligten arbeiten nach abgestimmten Prioritäten, vereinzelt kommt es zu Konflikten oder Doppelarbeit.',
        E: 'Interne Teams und externe Partner arbeiten nach einer priorisierten Roadmap mit regelmäßiger Abstimmung.'
      }
    },
    q08_responsibilities: {
      text: 'Wie klar sind Verantwortlichkeiten, Entscheidungsbefugnisse und Abhängigkeiten in Ihrer digitalen Arbeit geregelt?',
      answers: {
        A: 'Verantwortlichkeiten und Entscheidungsbefugnisse sind weitgehend ungeklärt.',
        B: 'Die Aufgaben sind bekannt, doch sobald Entscheidungen oder Abhängigkeiten auftreten, wird die Zuständigkeit unklar.',
        C: 'Zentrale Verantwortlichkeiten sind dokumentiert, Lücken und Überschneidungen bremsen die Umsetzung dennoch.',
        D: 'Verantwortung und Entscheidungsbefugnis sind in den laufenden Arbeitssträngen überwiegend klar.',
        E: 'Verantwortliche, Entscheider, Abhängigkeiten und Eskalationswege sind explizit geregelt und werden eingehalten.'
      }
    },
    q09_leadership_visibility: {
      text: 'Wie klar sieht die Führungsebene, welche digitalen Arbeiten vorankommen und welche messbaren Ergebnisse sie erzeugen?',
      answers: {
        A: 'Die Führungsebene hat kein durchgängiges Bild von digitalen Aktivitäten oder Ergebnissen.',
        B: 'Berichte konzentrieren sich vor allem auf erledigte Aufgaben statt auf Ergebnisse.',
        C: 'Es gibt einzelne Kennzahlen und Statusberichte, sie sind aber fragmentiert oder schwer zu deuten.',
        D: 'Die Führungsebene erhält regelmäßige Berichte zu Prioritäten, Fortschritt und wesentlichen Ergebnissen.',
        E: 'Die Führungsebene hat ein klares, belastbares Bild von Fortschritt, Ergebnissen, Blockaden und anstehenden Entscheidungen.'
      }
    },
    q10_roadmap: {
      text: 'Wie vollständig definiert Ihre 90-Tage-Roadmap Prioritäten, Verantwortliche, Zeitpunkte und messbare Ergebnisse?',
      answers: {
        A: 'Wir haben keine digitale 90-Tage-Roadmap.',
        B: 'Wir haben eine Liste von Vorhaben, aber keine klare Priorisierung, Verantwortung oder Terminierung.',
        C: 'Eine Roadmap existiert, doch einzelne Verantwortliche, Abhängigkeiten, Termine oder Ergebnisse fehlen.',
        D: 'Die Roadmap definiert die meisten Prioritäten, Verantwortlichen, Termine und messbaren Ergebnisse.',
        E: 'Wir steuern aktiv eine priorisierte 90-Tage-Roadmap, die Verantwortliche, Abhängigkeiten, Termine, KPIs und Führungsentscheidungen verbindet.'
      }
    }
  },

  areaResults: {
    leadership: {
      critical:   { title: 'Keine gemeinsame Richtung',      body: 'Prioritäten fehlen oder konkurrieren, eine ausreichend verantwortliche Führungsperson gibt es nicht.' },
      fragmented: { title: 'Verteilte Richtung',             body: 'Eine Richtung ist erkennbar, Abstimmung und Befugnis bleiben jedoch informell.' },
      developing: { title: 'Entstehende Ausrichtung',        body: 'Prioritäten und Verantwortung sind vorhanden, mit Lücken in Reihenfolge oder Kommunikation.' },
      aligned:    { title: 'Klare digitale Führung',         body: 'Gemeinsame Prioritäten leiten Entscheidungen, getragen von sichtbarer Führungsverantwortung.' }
    },
    website_ux: {
      critical:   { title: 'Unklare Kundenerfahrung',        body: 'Angebot und Conversion-Probleme sind nicht verlässlich verstanden.' },
      fragmented: { title: 'Geringe Conversion-Transparenz', body: 'Teile der Erfahrung funktionieren, Journeys und Reibungspunkte bleiben unklar.' },
      developing: { title: 'Website-Leistung im Aufbau',     body: 'Die Grundlagen sind solide, mit Lücken bei Botschaften, Belegen oder Optimierung.' },
      aligned:    { title: 'Conversion-bewusste Erfahrung',  body: 'Klarer Nutzen, gestützt auf Analytics, Nutzerbelege und Tests.' }
    },
    discoverability: {
      critical:   { title: 'Kaum Wissen über Auffindbarkeit',    body: 'Sichtbarkeit in Suche und KI ist kaum verstanden.' },
      fragmented: { title: 'Unverbundene Sichtbarkeitsarbeit',   body: 'Aktivität ist vorhanden, ohne durchgängigen Geschäftsbezug oder Messung.' },
      developing: { title: 'Auffindbarkeit im Aufbau',           body: 'Sichtbarkeit wird beobachtet, mit Lücken in Recherche, Autorität oder Conversion.' },
      aligned:    { title: 'Geschäftlich ausgerichtete Sichtbarkeit', body: 'Suche, Content und KI-Sichtbarkeit arbeiten als ein gemessenes System.' }
    },
    coordination: {
      critical:   { title: 'Umsetzung ohne Verantwortung',   body: 'Unklare Zuständigkeiten erzeugen Verzögerungen, Doppelarbeit und liegengebliebene Aufgaben.' },
      fragmented: { title: 'Fragmentierte Koordination',     body: 'Zuständigkeiten bestehen, Prioritäten und Entscheidungen bleiben aber uneinheitlich.' },
      developing: { title: 'Verbesserte Koordination',       body: 'Verantwortung funktioniert überwiegend, Übergaben und Abhängigkeiten erzeugen noch Reibung.' },
      aligned:    { title: 'Abgestimmte Umsetzung',          body: 'Teams teilen Prioritäten, Verantwortung und Eskalationswege.' }
    },
    measurement: {
      critical:   { title: 'Unsichtbarer Fortschritt',       body: 'Die Führungsebene kann Aktivität nicht mit Ergebnissen oder Entscheidungen verbinden.' },
      fragmented: { title: 'Aktivitätsgetriebenes Reporting', body: 'Berichte zeigen Aufgaben statt Fortschritt und Blockaden.' },
      developing: { title: 'Operative Steuerung im Aufbau',  body: 'Roadmap und Reporting funktionieren, einzelne Verantwortliche oder KPIs fehlen.' },
      aligned:    { title: 'Messbare Roadmap',               body: 'Prioritäten, Verantwortliche, Termine, Ergebnisse und Entscheidungen sind verbunden.' }
    }
  },

  areaRecommendations: {
    leadership: {
      critical:   'Eine verantwortliche Person und eine 90-Tage-Richtung festlegen',
      fragmented: 'Verteilte Prioritäten zu einem Führungsbild zusammenführen',
      developing: 'Prioritäten mit der Umsetzung verbinden',
      aligned:    'Klarheit sichern, während die Umsetzung wächst'
    },
    website_ux: {
      critical:   'Die Customer Journey verstehen, bevor erneut neu gestaltet wird',
      fragmented: 'Botschaften mit dem tatsächlichen Nutzerverhalten verbinden',
      developing: 'Zur kontinuierlichen Optimierung übergehen',
      aligned:    'Eine starke Erfahrung mit Belegen weiter ausbauen'
    },
    discoverability: {
      critical:   'Zuerst verstehen, wie Kunden suchen — dann mehr Content',
      fragmented: 'SEO und Content an geschäftliche Prioritäten koppeln',
      developing: 'Autorität in Suche und KI-Antworten stärken',
      aligned:    'Erkenntnisse in eine wiederholbare Wachstumsschleife überführen'
    },
    coordination: {
      critical:   'Verantwortung klären, bevor ein weiterer Dienstleister dazukommt',
      fragmented: 'Ein einheitliches Koordinationsmodell schaffen',
      developing: 'Reibung bei Übergaben und Abhängigkeiten beseitigen',
      aligned:    'Koordination erhalten, während Vorhaben wachsen'
    },
    measurement: {
      critical:   'Prioritäten und Fortschritt in einer Roadmap sichtbar machen',
      fragmented: 'Von Aktivitäts- zu Ergebnisberichten wechseln',
      developing: 'Roadmap und Reporting verbinden',
      aligned:    'Fokus halten, während sich Chancen erweitern'
    }
  },

  profiles: {
    fragmented: {
      label: 'Fragmentiert',
      headline: 'Digitale Arbeit findet statt, aber das System darum herum ist noch nicht verbunden.',
      body: 'Es gibt sinnvolle Aktivität, doch Prioritäten, Verantwortung, Kundenerfahrung, Auffindbarkeit und Messung arbeiten nicht als ein System.',
      risk: 'Mehr Aktivität kann die Komplexität erhöhen, ohne den Fortschritt entsprechend zu vergrößern.',
      recommendation: 'Klarheit schaffen, bevor weitere digitale Aktivität hinzukommt.'
    },
    partially_aligned: {
      label: 'Teilweise ausgerichtet',
      headline: 'Starke Elemente sind vorhanden, doch zwischen Strategie und Umsetzung bricht die Ausrichtung.',
      body: 'Wichtige Grundlagen funktionieren in Teilen des Unternehmens. Die zentrale Einschränkung ist die Uneinheitlichkeit zwischen Teams, Dienstleistern, Kanälen und Entscheidungen.',
      risk: 'Gute Vorhaben bleiben hinter ihren Möglichkeiten, weil Abhängigkeiten und Prioritäten nur teilweise verbunden sind.',
      recommendation: 'Die bereits vorhandenen starken Elemente miteinander verbinden.'
    },
    growth_ready: {
      label: 'Wachstumsbereit',
      headline: 'Ihre digitalen Grundlagen tragen fokussiertes, messbares Wachstum.',
      body: 'Prioritäten, Kundenerfahrung, Teams und Messung sind verbunden. Die Chance liegt darin, verbleibende Einschränkungen zu lösen und zu skalieren, ohne Klarheit zu verlieren.',
      risk: 'Wachstum erzeugt Reibung, wenn die Umsetzung schneller skaliert als Verantwortung und Messung.',
      recommendation: 'Das System auf die Einschränkungen ausrichten, die am meisten wiegen.'
    }
  },

  criticalOverride: {
    flagLabel: 'Kritische Reibung erkannt',
    note: 'Mindestens ein Bereich zeigt kritische Reibung. Das begrenzt, wie weit die vorhandenen Stärken das Unternehmen tragen können.'
  },

  leadFields: {
    firstname: { label: 'Vorname' },
    email:     { label: 'Geschäftliche E-Mail' },
    company:   { label: 'Unternehmen' },
    jobtitle:  { label: 'Position' },
    website:   { label: 'Website des Unternehmens' },
    primary_priority: {
      label: 'Wichtigste digitale Priorität',
      options: {
        '':                'Auswählen, falls zutreffend',
        leadership:        'Digitale Prioritäten & Führung',
        website_ux:        'Website, UX & Conversion',
        discoverability:   'SEO, Content & Auffindbarkeit',
        coordination:      'Teams, Agenturen & Verantwortung',
        measurement:       'Messung & Roadmap'
      }
    }
  },

  consent: {
    marketing: {
      label: 'Senden Sie mir gelegentlich praxisnahe Impulse zu digitaler Strategie, UX, Auffindbarkeit und Wachstum.'
    }
  },

  ui: {
    questionProgress: 'Frage {number} von {total}',
    questionAnnounce: 'Frage {number} von {total}. {text}',
    back: 'Zurück',
    next: 'Weiter',
    seeScore: 'Ergebnis anzeigen',
    answerRequired: 'Bitte wählen Sie die Aussage, die am ehesten beschreibt, wie Ihr Unternehmen heute arbeitet.',
    answerRequiredAnnounce: 'Keine Antwort ausgewählt. Bitte wählen Sie eine Aussage, um fortzufahren.',
    scoreHeading: 'Ihr GRID-OS Digital Alignment Score',
    previewAnnounce: 'Ihr Ergebnis lautet {score} von 100. Profil: {profile}. Geben Sie Ihre Daten ein, um die vollständige Auswertung aller fünf Bereiche zu sehen.',
    optionalSuffix: ' (optional)',
    fieldRequired: '{label} ist ein Pflichtfeld.',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    emailFreeMail: 'Bitte verwenden Sie Ihre geschäftliche E-Mail-Adresse.',
    formErrorOne: 'Es gibt ein Problem mit dem Formular: {problem}',
    formErrorMany: 'Es gibt {count} Probleme mit dem Formular. Bitte prüfen Sie die markierten Felder.',
    privacyBody: 'Ihre Angaben werden verwendet, um das Ergebnis bereitzustellen und Ihre Anfrage zu bearbeiten. Marketing-Kommunikation ist optional und erfordert eine gesonderte Einwilligung. ',
    privacyLink: 'Zur Datenschutzerklärung.',
    sending: 'Wird gesendet …',
    sendingAnnounce: 'Ihre Daten werden gesendet.',
    submitFailed: 'Ihre Angaben konnten gerade nicht gesendet werden. Ihr Ergebnis ist nicht verloren — wählen Sie „{label}“, um es erneut zu versuchen.',
    submitFailedAnnounce: 'Senden fehlgeschlagen. Ihr Ergebnis ist gesichert. Sie können es erneut versuchen.',
    riskLabel: 'Risiko: ',
    areasHeading: 'Ihre fünf Bereiche',
    strongestLabel: 'Ihr stärkster Bereich',
    primaryFrictionLabel: 'Ihr größter Reibungsbereich',
    secondaryFrictionLabel: 'Ihr zweitgrößter Reibungsbereich',
    tiedNote: 'Gleichauf mit mindestens einem weiteren Bereich.',
    evenNote: 'Ihre fünf Bereiche erreichen dieselbe Punktzahl. Das deutet auf ein durchgängiges Arbeitsmuster hin und nicht auf eine einzelne Einschränkung — die Reihenfolge zählt daher mehr als die Wahl eines Bereichs.',
    prioritiesHeading: 'Ihre ersten drei Prioritäten',
    startHereLabel: 'Hier beginnen: ',
    restart: 'Assessment neu starten',
    restartAnnounce: 'Assessment zurückgesetzt. Sie können neu beginnen.',
    disclaimer: 'Der GRID-OS Digital Friction Check liefert eine richtungsweisende Einschätzung auf Basis der gemachten Angaben. Er ist keine rechtliche, finanzielle, sicherheitstechnische oder technische Beratung und ersetzt kein formelles Audit.',
    fullResultAnnounce: 'Vollständiges Ergebnis bereit. Ergebnis {score} von 100, Profil {profile}. Größter Reibungsbereich: {area}.'
  }
};
